import { memo } from 'react';
import PropTypes from 'prop-types';
import { IMAGE_TYPE_SVG, MIME_TYPE_SVG } from './constants';
import styles from '../../styles.module.scss';

const ProductSchematicsImage = ({ onLoad, type, title, url }) =>
  type === IMAGE_TYPE_SVG ? (
    <object
      aria-label={title}
      className={styles['product-schematic-svg']}
      data={url}
      data-testid="schematics-image"
      onLoad={onLoad}
      type={MIME_TYPE_SVG}
    />
  ) : (
    <img
      alt={title}
      className={styles['product-schematic-svg']}
      loading="lazy"
      onLoad={onLoad}
      src={url}
    />
  );

ProductSchematicsImage.displayName = 'ProductSchematicsImage';
ProductSchematicsImage.propTypes = {
  onLoad: PropTypes.func,
  title: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.string.isRequired
};

export default memo(ProductSchematicsImage);
